/**
 * Abstract class that all bulk upload handlers should extend to
 * allow for a common interface of upload-related activities.
 *
 * @category Upload Handlers
 * @template InputType - The type of the input file to be uploaded.
 * @template ReturnType - The type of the return value after the upload is processed.
 */
export class Uploader {
    /**
     * Handlers need access to MadSDK
     * @param sdk Instance of MadSDK to use for lookups
     */
    constructor(sdk) {
        /** Saves/creates assets based on given file */
        this.save = async (file) => {
            if (!file) {
                throw new Error("file not provided");
            }
            const user = this.sdk.getCurrentUser();
            if (!user) {
                throw new Error("user is not logged in");
            }
            return this.saveUpload(file);
        };
        this.sdk = sdk;
    }
}
//# sourceMappingURL=uploader.js.map